var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_479_3893",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_479_3893",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrUlEQVR4nO2YPU4DYQxER3Rw6dyBHyVniHaaNOsT0Ox3FqCBNmiltAghhXjsnSe5+4rxk+XVGjDGGGOMMcaYrXI6jYcplhfO44Mxzko1zcv7FMvz8fh6j+pMMQ7ZQn8VHuOAyux25zvG+Cog+nPNiqpY9A0psjr2qM76oeE8ntYPj57g5W2ax2OLj6ExxhhjTO87BjvdQyr8jLD6PaTK7zWr30Ms+oZsbHXskYXyHYNd7yHZQvhPBTWyhdCi82VtYqK7vk9DTQQtWlOcJ/qCRYuKoCdaU1z51VG9oEa2EFp0vixPdOSL9OoIjYIa2UK4ddFd36ehJoIWrSnOE33BokVF0BOtKa786qheUCNbCC06X5YnOvJFenWERkGNbCHcuuiu79NQE0GL1hTnib5g0aIi6InWFFd+dVQvqJEthBadL8sTHfkivTpCo6BGthBuXfS13lfPg66NUSwPujZGsTzo2hjF8qBrYxTLg66NUSzP1fgp6F8LTfOga2MUy4OujVEsD7o2RrE86NoYxfKga2MUy4OujVEsD7o2RrE86NoYxfIYY4wxxhhjDFT5BnvzTI/R1JLbAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.e66b14b4d8b5b10bd6fa8876f665b006.svg";
export { ForwardRef as ReactComponent };